const translations: Record<string, string> = {
  "ak_bud_month": "Month",
  "ak_bud_year": "Year",
  "ak_bud_accuracy": "Accuracy",
  "ak_bud_cash": "Cash",
  "ak_bud_low": "Low",
  "ak_bud_base": "Base",
  "ak_bud_high": "High",
  "ak_bud_draft": "Draft",
  "ak_bud_final": "Final",
  "ak_bud_jan": "Jan",
  "ak_bud_feb": "Feb",
  "ak_bud_mar": "Mar",
  "ak_bud_apr": "Apr",
  "ak_bud_may": "May",
  "ak_bud_jun": "Jun",
  "ak_bud_jul": "Jul",
  "ak_bud_aug": "Aug",
  "ak_bud_sep": "Sep",
  "ak_bud_oct": "Oct",
  "ak_bud_nov": "Nov",
  "ak_bud_dec": "Dec",
  "ak_bud_low_2": "low",
  "ak_bud_base_2": "base",
  "ak_bud_high_2": "high",
  "ak_bud_january": "January",
  "ak_bud_february": "February",
  "ak_bud_march": "March",
  "ak_bud_april": "April",
  "ak_bud_may_2": "May",
  "ak_bud_june": "June",
  "ak_bud_july": "July",
  "ak_bud_august": "August",
  "ak_bud_september": "September",
  "ak_bud_october": "October",
  "ak_bud_november": "November",
  "ak_bud_december": "December",
  "ak_bud_year_http": "year: HTTP {{s}}",
  "ak_bud_month_http": "month: HTTP {{s}}",
  "ak_bud_budget_year": "budget year {{p}}",
  "ak_bud_budget_year_2": "budget year",
  "ak_bud_price_scenario": "price scenario: {{s}}",
  "ak_bud_approved": "approved",
  "ak_bud_reference_form": "reference form",
  "ak_bud_failed_to_load_the_budget": "Failed to load the budget: {{err}}",
  "ak_bud_actual_mn_days": "actual {{r}} mn · {{d}} days",
  "ak_bud_incl_bess_mn": "incl. BESS {{v}} mn",
  "ak_bud_plan": "plan",
  "ak_bud_margin": "margin {{v}}",
  "ak_bud_actual_mwh": "actual {{v}} MWh",
  "ak_bud_avg_price_uah_mwh": "avg. price {{v}} UAH/MWh",
  "ak_bud_vs_budget": "{{v}} vs budget",
  "ak_bud_the_monthly_breakdown_has_been_entered": "The monthly breakdown has been entered for the base scenario only. Year totals for all three are in “Parameters” on the “Year” tab.",
  "ak_bud_version": "version {{st}} · {{src}}",
  "ak_bud_uah_excl_vat": "UAH excl. VAT · {{f}}",
  "ak_bud_approved_2": "approved: {{by}}",
  "ak_bud_fixed_directory_items_against_actual_a": "Fixed directory items against actual accruals and payments; the difference is accounts payable.",
  "ak_bud_the_payment_calendar_is_calculated_fro": "The payment calendar is calculated from the approved annual budget — there is none yet for this station, or the data is loading.",
  "ak_bud_failed_to_load": "failed to load",
  "ak_bud_no_station_selected": "no station selected",
  "ak_bud_budget": "Budget",
  "ak_bud_loading": "Loading…",
  "ak_bud_there_is_no_approved_budget_version_fo": "There is no approved budget version for this station yet. The module pilot is the Luchky solar plant.",
  "ak_bud_revenue": "Revenue",
  "ak_bud_uah_mn": "UAH mn",
  "ak_bud_grid_export": "Grid export",
  "ak_bud_mwh": "MWh",
  "ak_bud_debt_service": "Debt service",
  "ak_bud_interest_fees_principal": "interest, fees, principal",
  "ak_bud_month_forecast": "Month forecast",
  "ak_bud_actual_plan_for_the_remaining_days": "actual + plan for the remaining days",
  "ak_bud_month_summary": "Month summary",
  "ak_bud_daily_profile_prices_and_release_plan": "Daily profile: prices and release plan",
  "ak_bud_plan_vs_actual_by_day": "Plan vs actual by day",
  "ak_bud_costs_accrued_and_paid": "Costs: accrued and paid",
  "ak_bud_requires_access_to_accounting": "requires access to accounting",
  "ak_bud_by_month": "By month",
  "ak_bud_break_even_and_dscr": "Break-even and DSCR",
  "ak_bud_fixed_costs_1_5_5_variable": "fixed costs / (1 − 5.5% variable)",
  "ak_bud_loan": "Loan",
  "ak_bud_see_the_version_note_below": "see the version note below",
  "ak_bud_parameters": "Parameters",
  "ak_bud_pending_approval": "pending approval",
  "ak_bud_superseded": "superseded",
  "ak_bud_draft_t_5": "draft T−5",
  "ak_bud_final_t_1": "final T−1",
  "ak_bud_reference_import": "reference import",
  "ak_bud_failed_to_approve_http": "Failed to approve: HTTP {{s}}",
  "ak_bud_created": "created {{d}}",
  "ak_bud_approved_by": " · approved by {{by}} {{d}}",
  "ak_bud_scenario": " · scenario {{s}}",
  "ak_bud_vs_previous": "vs previous ({{s}}):",
  "ak_bud_revenue_2": "revenue",
  "ak_bud_mn": "mn",
  "ak_bud_export": "export",
  "ak_bud_stress": "stress",
  "ak_bud_approve": "Approve",
  "ak_bud_inactive": "inactive",
  "ak_bud_spec_a2_rules_draft_t_5_final_t_1_at_0": "Spec A2 rules: draft T−5, final T−1 at 09:00, auto-approval at 12:00 if the finance department has not approved manually. The auto-approval mechanism is implemented but not yet scheduled — this is the process owner's decision.",
  "ak_bud_failed_to_approve_the_version": "Failed to approve the version",
  "ak_bud_auto": " (auto)",
  "ak_bud_monthly_budget_versions": "Monthly budget versions",
  "ak_bud_versions_are_not_edited_each_revision": "versions are not edited — each revision is a separate row",
  "ak_bud_no_versions_for_the_month_yet_generate": "No versions for the month yet. Generate a draft or final with the button in the header.",
  "ak_bud_approve_this_version_the_other_version": "Approve this version; the other versions of the period will become superseded",
  "ak_bud_indexation_from": "Indexation {{p}} from {{d}}",
  "ak_bud_metric": "Metric",
  "ak_bud_grid_export_mwh": "Grid export, MWh",
  "ak_bud_average_sale_price_uah_mwh": "Average sale price, UAH/MWh",
  "ak_bud_revenue_uah_mn": "Revenue, UAH mn",
  "ak_bud_incl_bess_effect": "incl. BESS effect",
  "ak_bud_variable_costs_uah_mn": "Variable costs, UAH mn",
  "ak_bud_fixed_opex_uah_mn": "Fixed OPEX, UAH mn",
  "ak_bud_ebitda_uah_mn": "EBITDA, UAH mn",
  "ak_bud_finance_costs_uah_mn": "Finance costs, UAH mn",
  "ak_bud_pre_tax_profit_uah_mn": "Pre-tax profit, UAH mn",
  "ak_bud_income_tax_uah_mn": "Income tax, UAH mn",
  "ak_bud_net_profit_uah_mn": "Net profit, UAH mn",
  "ak_bud_loan_principal_repayment_uah_mn": "Loan principal repayment, UAH mn",
  "ak_bud_cash_flow_after_repayment_uah_mn": "Cash flow after repayment, UAH mn",
  "ak_bud_cumulative_uah_mn": "Cumulative, UAH mn",
  "ak_bud_fixed_mn": "Fixed, mn",
  "ak_bud_break_even_revenue_mn": "Break-even revenue, mn",
  "ak_bud_revenue_plan_mn": "Revenue plan, mn",
  "ak_bud_safety_margin": "Safety margin",
  "ak_bud_break_even_price_base": "Break-even price BASE",
  "ak_bud_break_even_export_mwh": "Break-even export, MWh",
  "ak_bud_cash_break_even_mn": "Cash break-even, mn",
  "ak_bud_debt_service_coverage_dscr_ebitda_inte": "Debt service coverage (DSCR = EBITDA / interest + fee + account servicing + principal)",
  "ak_bud_balance_eur": "Balance, EUR",
  "ak_bud_fx_rate": "FX rate",
  "ak_bud_interest_mn": "Interest, mn",
  "ak_bud_principal_eur": "Principal, EUR",
  "ak_bud_principal_uah_mn": "Principal, UAH mn",
  "ak_bud_fee_k": "Fee, k",
  "ak_bud_account_servicing_k": "Account servicing, k",
  "ak_bud_debt_service_mn": "Debt service, mn",
  "ak_bud_version_assumptions": "Version assumptions",
  "ak_bud_fixed_opex_items_uah_month": "Fixed OPEX items, UAH/month",
  "ak_bud_year_by_price_scenario_uah_mn": "Year by price scenario, UAH mn",
};

export default translations;
